import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ViewDialogData {
	title: string;
	data: any;
}

@Component({
	selector: 'app-dial-dialog-modal',
	templateUrl: './custom-dial-dialog.component.html',
  styleUrls: ['./custom-dial-dialog.component.scss']
})
export class ModalDialDialogComponent {
	public errorMessage: string = '';
  public loading: boolean = false;
  public hasFormErrors: boolean = false;
	public dataVal: string = '';

	constructor(private zone: NgZone,
		public dialogRef: MatDialogRef<ModalDialDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ViewDialogData) {
	}
  closeModal(data): void {
		this.zone.run(() => {
		   this.dialogRef.close(data);
		});
  }
}
